// extracted by mini-css-extract-plugin
module.exports = {"LightestProduct":"LightestProduct_LightestProduct__1KGcZ"};